import { cpf } from 'cpf-cnpj-validator';
import { validateEmail } from '../../../shared/validate/validate';

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = 'Esse campo não pode ficar vazio';
  }
  if (values.active) {
    if (values.cpf) {
      const cpfIsValid = cpf.isValid(values.cpf);
      if (!cpfIsValid) {
        errors.cpf = 'Informe um CPF válido!';
      }
    } else {
      errors.cpf = 'Esse campo não pode ficar vazio';
    }
    if (!values.profiles) {
      errors.profiles = 'Selecione ao menos um perfil de acesso';
    }
    if (values.profiles) {
      if (values.profiles.length === 0) {
        errors.profiles = 'Selecione ao menos um perfil de acesso';
      }
    }
    if (!values.terms) {
      errors.terms = 'Selecione ao menos um período letivo';
    }
    if (values.terms) {
      if (values.terms.length === 0) {
        errors.terms = 'Selecione ao menos um período letivo';
      }
    }
    if (!values.classes) {
      errors.classes = 'Selecione ao menos uma turma';
    }
    if (values.classes) {
      if (values.classes.length === 0) {
        errors.classes = 'Selecione ao menos uma turma';
      }
    }
    if (values.zipCode) {
      if (!values.addressNumber) {
        errors.addressNumber = 'Esse campo não pode ficar vazio';
      }
    }
  }

  if (values.cpf && values.cpf.length < 11) {
    errors.cpf = 'CPF Inválido';
  }
  if (values.zipCode && values.zipCode.length < 8) {
    errors.zipCode = 'CEP Inválido';
  }
  if (!values.user) {
    errors.user = 'Esse campo não pode ficar vazio';
  }
  if (!values.password) {
    errors.password = 'Esse campo não pode ficar vazio';
  }

  if (values.email && values.email.length) {
    if (!validateEmail(values.email)) {
      errors.email = 'Este endereço de e-mail é inválido';
    }
  }

  if (!values.newPassword) {
    errors.newPassword = 'Informe sua nova senha';
  }
  if (values.newPassword) {
    if (!values.confirmPassword) {
      errors.confirmPassword = 'Confirme sua nova senha';
    }
    if (
      values.confirmPassword &&
      values.newPassword !== values.confirmPassword
    ) {
      errors.confirmPassword = 'Senhas não conferem!';
    }
  }

  return errors;
};

export default validate;
